function showHide (modalWindow) {
    if (modalWindow.classList.contains('no-show')) {
        modalWindow.classList.remove('no-show');
        document.body.classList.add('overflow');

        setTimeout(function () {
              modalWindow.classList.remove('hidden');
        }, 20);
      } else {
        modalWindow.classList.add('hidden');  
        document.body.classList.remove('overflow');  
        modalWindow.addEventListener('transitionend', function(e) {
              modalWindow.classList.add('no-show');
        }, {
            capture: false,
            once: true,
            passive: false
        });
    }
}


export default showHide;